'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var tslib = require('tslib');
var React = require('react');
var mergeRefs = require('react-merge-refs');
var cn = require('classnames');
var coreComponentsPopover = require('@alfalab/core-components-popover');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);
var mergeRefs__default = /*#__PURE__*/_interopDefaultCompat(mergeRefs);
var cn__default = /*#__PURE__*/_interopDefaultCompat(cn);

var defaultColors = {"hint":"tooltip__hint_d4vce","arrow":"tooltip__arrow_d4vce","tooltip":"tooltip__tooltip_d4vce"};
require('./default.css')

var styles = {"component":"tooltip__component_r5nhn","popper":"tooltip__popper_r5nhn","hint":"tooltip__hint_r5nhn","target":"tooltip__target_r5nhn","overlap":"tooltip__overlap_r5nhn"};
require('./index.css')

var invertedColors = {"tooltip":"tooltip__tooltip_9lrs7","arrow":"tooltip__arrow_9lrs7","hint":"tooltip__hint_9lrs7"};
require('./inverted.css')

var colorStyles = {
    default: defaultColors,
    inverted: invertedColors,
};
var TooltipDesktop = function (_a) {
    var children = _a.children, content = _a.content, _b = _a.trigger, trigger = _b === void 0 ? 'hover' : _b, _c = _a.onCloseDelay, onCloseDelay = _c === void 0 ? 300 : _c, _d = _a.onOpenDelay, onOpenDelay = _d === void 0 ? 300 : _d, dataTestId = _a.dataTestId, forcedOpen = _a.open, _e = _a.offset, offset = _e === void 0 ? [0, 16] : _e, position = _a.position, contentClassName = _a.contentClassName, arrowClassName = _a.arrowClassName, popoverClassName = _a.popoverClassName, updatePopover = _a.updatePopover, targetClassName = _a.targetClassName, zIndex = _a.zIndex, onClose = _a.onClose, onOpen = _a.onOpen, getPortalContainer = _a.getPortalContainer, _f = _a.view, view = _f === void 0 ? 'tooltip' : _f, _g = _a.targetRef, targetRef = _g === void 0 ? null : _g, fallbackPlacements = _a.fallbackPlacements, _h = _a.preventOverflow, preventOverflow = _h === void 0 ? true : _h, _j = _a.availableHeight, availableHeight = _j === void 0 ? false : _j, _k = _a.anchor, anchor = _k === void 0 ? null : _k, _l = _a.colors, colors = _l === void 0 ? 'default' : _l, useAnchorWidth = _a.useAnchorWidth;
    var _m = React.useState(!!forcedOpen), visible = _m[0], setVisible = _m[1];
    var _o = React.useState(null), target = _o[0], setTarget = _o[1];
    var contentRef = React.useRef(null);
    var timer = React.useRef(0);
    var show = forcedOpen === undefined ? visible : forcedOpen;
    var open = function () {
        if (!show) {
            setVisible(true);
            if (onOpen) {
                onOpen();
            }
        }
    };
    var close = React.useCallback(function () {
        if (show) {
            setVisible(false);
            if (onClose) {
                onClose();
            }
        }
    }, [onClose, show]);
    var toggle = function () {
        if (show) {
            close();
        }
        else {
            open();
        }
    };
    var clickedOutside = React.useCallback(function (node) {
        if (target && target.contains(node)) {
            return false;
        }
        if (contentRef.current && contentRef.current.contains(node)) {
            return false;
        }
        return true;
    }, [target]);
    React.useEffect(function () {
        var handleBodyClick = function (event) {
            var eventTarget = event.target;
            if (clickedOutside(eventTarget)) {
                close();
            }
        };
        document.body.addEventListener('click', handleBodyClick);
        document.body.addEventListener('touchstart', handleBodyClick);
        return function () {
            document.body.removeEventListener('click', handleBodyClick);
            document.body.removeEventListener('touchstart', handleBodyClick);
            clearTimeout(timer.current);
        };
    }, [clickedOutside, close]);
    var handleTargetClick = function () {
        toggle();
    };
    var handleMouseOver = function () {
        clearTimeout(timer.current);
        timer.current = window.setTimeout(function () {
            open();
        }, onOpenDelay);
    };
    var handleMouseOut = function () {
        clearTimeout(timer.current);
        timer.current = window.setTimeout(function () {
            close();
        }, onCloseDelay);
    };
    var handleTouchStart = function (event) {
        var eventTarget = event.target;
        clearTimeout(timer.current);
        if (clickedOutside(eventTarget)) {
            timer.current = window.setTimeout(function () {
                close();
            }, onCloseDelay);
        }
        else {
            open();
        }
    };
    var onClickProps = { onClick: handleTargetClick };
    var onHoverProps = {
        onMouseOver: handleMouseOver,
        onMouseOut: handleMouseOut,
        onTouchStart: handleTouchStart,
    };
    var getTargetProps = function () {
        var props = {
            className: cn__default.default(styles.target, targetClassName),
        };
        switch (trigger) {
            case 'click':
                return tslib.__assign(tslib.__assign({}, props), onClickProps);
            case 'hover':
                return tslib.__assign(tslib.__assign({}, props), onHoverProps);
            default:
                return {};
        }
    };
    var getContentProps = function () {
        var props = {
            ref: contentRef,
            'data-test-id': dataTestId,
            className: cn__default.default(styles.component, contentClassName),
        };
        switch (trigger) {
            case 'hover':
                return tslib.__assign(tslib.__assign({}, props), onHoverProps);
            default:
                return props;
        }
    };
    return (React__default.default.createElement(React.Fragment, null,
        React__default.default.createElement("div", tslib.__assign({ ref: mergeRefs__default.default([targetRef, setTarget]) }, getTargetProps()),
            children.props.disabled && React__default.default.createElement("div", { className: styles.overlap }),
            children),
        React__default.default.createElement(coreComponentsPopover.Popover, { anchorElement: anchor || target, open: show, getPortalContainer: getPortalContainer, arrowClassName: cn__default.default(arrowClassName, styles.arrow, colorStyles[colors].arrow), popperClassName: cn__default.default(styles.popper, styles[view], colorStyles[colors][view]), className: popoverClassName, offset: offset, withArrow: true, position: position, update: updatePopover, zIndex: zIndex, fallbackPlacements: fallbackPlacements, preventOverflow: preventOverflow, availableHeight: availableHeight, useAnchorWidth: useAnchorWidth },
            React__default.default.createElement("div", tslib.__assign({}, getContentProps()), content))));
};

exports.TooltipDesktop = TooltipDesktop;
